import * as Yup from 'yup'

export const libraryImpactSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'validation-name-min')
    .max(100, 'validation-name-max')
    .required('validation-required'),
  description: Yup.string()
    .min(0)
    .max(30000, 'validation-description-max')
    .required('validation-required'),
  url: Yup.string().nullable().url('validation-url-invalid'),
})
